export const CocoCelebrationAssets = [
  {
    type: 'christmas',
    mascotPath: '/assets/coco-celebrations/christmas/mascot.svg',
    avatarPath: '/assets/coco-celebrations/christmas/avatar.svg',
    globalAnimation: 'snow'
  },
  {
    type: 'ramadan',
    mascotPath: '/assets/coco-celebrations/ramadan/mascot.svg',
    avatarPath: '/assets/coco-celebrations/ramadan/avatar.svg',
    globalAnimation: 'star'
  },
  {
    type: 'lunar-new-year',
    mascotPath: '/assets/coco-celebrations/lunar-new-year/mascot.svg',
    avatarPath: '/assets/coco-celebrations/lunar-new-year/avatar.svg',
    globalAnimation: 'lantern'
  },
  {
    type: 'winter',
    mascotPath: '/assets/coco-celebrations/winter/mascot.svg',
    avatarPath: '/assets/coco-celebrations/winter/avatar.svg',
    globalAnimation: 'snow'
  },
  {
    type: 'halloween',
    mascotPath: '/assets/coco-celebrations/halloween/mascot.svg',
    avatarPath: '/assets/coco-celebrations/halloween/avatar.png',
    globalAnimation: 'bat'
  },
  {
    type: 'holi',
    mascotPath: '/assets/coco-celebrations/holi/mascot.svg',
    avatarPath: null,
    globalAnimation: null
  },
  {
    type: 'default',
    mascotPath: '/assets/coco-celebrations/default/mascot.svg',
    avatarPath: '/assets/coco-celebrations/default/avatar.png',
    globalAnimation: null
  }
];
